import { render, staticRenderFns } from "./ProductAndPackageManagement.vue?vue&type=template&id=be1e4ae4&scoped=true"
import script from "./ProductAndPackageManagement.vue?vue&type=script&lang=js"
export * from "./ProductAndPackageManagement.vue?vue&type=script&lang=js"
import style0 from "./ProductAndPackageManagement.vue?vue&type=style&index=0&id=be1e4ae4&prod&lang=scss&scoped=true"
import style1 from "./ProductAndPackageManagement.vue?vue&type=style&index=1&id=be1e4ae4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be1e4ae4",
  null
  
)

export default component.exports